import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FieldErrorComponent } from './field-error.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    FieldErrorComponent,
  ],
  exports: [
    FieldErrorComponent,
  ],
})
export class FieldErrorModule { }
